import type { ChatbotLinkHandler } from "../types";

/**
 * In-app routes (e.g. `/appointments/abc-123`, a doctor or location page)
 * open in a new tab so the conversation stays put. Matches root-relative
 * paths only — absolute URLs are handled by `externalLinkHandler`, and
 * fragment-only anchors like `#table-16-3` are handled by the AMA handler.
 */
export const internalRouteHandler: ChatbotLinkHandler = {
  id: "internal-route",
  matches: (href) => href.startsWith("/") && !href.startsWith("//"),
  onClick: (href) => {
    window.open(href, "_blank", "noopener,noreferrer");
  },
};
